import { getOriginalConsoleError } from "@/lib/observability/console-base";

export function normalizeError(error: unknown): Error {
  if (error instanceof Error) return error;

  if (typeof error === "string") {
    return new Error(error);
  }

  try {
    return new Error(JSON.stringify(error));
  } catch (e) {
    const log = getOriginalConsoleError();
    log(
      "[observability] Caught error in lib/observability/normalize-error.ts",
      e
    );
    return new Error(String(e));
  }
}

export function normalizeConsoleError(args: unknown[]): Error {
  for (const arg of args) {
    if (arg instanceof Error) return arg;
  }

  const log = getOriginalConsoleError();
  const stringParts = args
    .map((arg) => {
      if (typeof arg === "string") return arg;
      if (arg instanceof Error) return `${arg.name}: ${arg.message}`;
      try {
        return JSON.stringify(arg);
      } catch (e) {
        log(
          "[observability] Caught error in lib/observability/normalize-error.ts",
          e
        );
        return String(arg);
      }
    })
    .filter(Boolean);

  const message = stringParts.join(" ") || "console.error called";
  return new Error(message);
}
